/* eslint-disable */
import * as React from "react";
import { Button, Flex, Grid } from "@aws-amplify/ui-react";
import { Accordion, Form, Row, Col, Table, Modal  } from 'react-bootstrap'
import { getOverrideProps } from "@aws-amplify/ui-react/internal";
import { Player } from "../models";
import { fetchByPath, validateField } from "./utils";
import { DataStore, Auth } from "aws-amplify";
import { useNavigate, useLocation } from "react-router-dom";
import { playDrumrollAudio } from "../audioManager";
import VoiceScoreButton from "./VoiceScoreButton";
import { updateActiveGame, removeActiveGame } from "../lib/activeGameService";
import { calculateNewValue } from "@testing-library/user-event/dist/utils";


export default function GamePlay(props) {
    const {
        overrides,
        ...rest
      } = props;

    const [errors, setErrors] = React.useState({});

    const gameData = React.useRef({});
    const [ gameSummaryData, setGameSummaryData ] = React.useState([])
    const [ roundSummaryData, setRoundSummaryData]= React.useState([])

    const navigate= useNavigate();
    const location = useLocation();
    // Support resume via activeGameSnapshot
    const resumedSnapshot = location.state?.activeGameSnapshot || null;
    console.log("Game: ", location.state?.game || (resumedSnapshot ? 'resumed' : null));
    const game = location.state?.game || null;
    console.log("Players: ", location.state?.players || (resumedSnapshot ? resumedSnapshot.players : null));
    const players = resumedSnapshot?.players || location.state?.players || [];
    const initialDealerFromState = resumedSnapshot?.initialDealer || location.state?.initialDealer || players[0]?.Name || "";
    const [initialDealer] = React.useState(initialDealerFromState);
    const initialCompletedRounds = location.state?.activeGameSnapshot?.completedRounds || [];
    const highestCompletedRound = initialCompletedRounds.reduce(
        (highest, round) => Math.max(highest, Number(round.roundNumber) || 0),
        0
    );
    const [currentRound, setCurrentRound] = React.useState(
        resumedSnapshot && highestCompletedRound > 0
            ? highestCompletedRound + 1
            : (location.state?.activeGameSnapshot?.currentRound || 1)
    )
    const [currentPanel, setCurrentPanel] = React.useState(0)
    const activeGameIdFromState = location.state?.activeGameId || null;
    const [activeGameId, setActiveGameId] = React.useState(activeGameIdFromState);

    async function savePlayer(p, total) {
        //try {
            let pl = await DataStore.query(Player, p.id)
            let player= new Player.copyOf(pl, (updated) => {
                updated.total = total
            })
            await DataStore.save(player);

        //} catch (err) {
        //    console.log("Error saving: ",p, "Message: ", err.message);
        //}
    }

    React.useEffect(() => {
        newRound()
    },[currentRound]);

    const [roundMap, setRoundMap] = React.useState(new Map());
    const roundMapRef = React.useRef(roundMap);
    const [Rounds, setRounds] = React.useState([])
    const [showRoundSummary, setShowRoundSummary] = React.useState(false);
    const [lastRoundData, setLastRoundData] = React.useState(null);
    const [showEndGameConfirm, setShowEndGameConfirm] = React.useState(false);

    const getDealerForRound = (roundNumber) => {
        const dealerIndex = players.findIndex(player => player.Name === initialDealer);
        if (dealerIndex === -1 || players.length === 0) return players[0]?.Name || "";
        const adjustedIndex = (dealerIndex + roundNumber - 1) % players.length;
        return players[adjustedIndex].Name;
    };

    const editableRoundNumbers = new Set(
        Rounds.map((round) => Number(round.props['data-round']))
    );
    const restoredRoundPanels = Array.from(roundMap.entries())
        .filter(([round]) => !editableRoundNumbers.has(Number(round)))
        .sort(([roundA], [roundB]) => roundA - roundB)
        .map(([round, playerRoundMap]) => (
            <Accordion.Item key={`restored-round-${round}`} eventKey={`restored-${round}`}>
                <Accordion.Header>Round {round} - Dealer: {getDealerForRound(round)}</Accordion.Header>
                <Accordion.Body>
                    {players.map((player) => {
                        const score = playerRoundMap.get(player.Name);
                        if (!score) return null;
                        return (
                            <div key={`${round}-${player.Name}`} className="mb-3">
                                <strong>{player.Name}</strong>
                                <div className="d-flex justify-content-between">
                                    <Form.Control
                                        type="number"
                                        defaultValue={score.Unprotected ?? 0}
                                        onBlur={(event) => updateGameData(round, player.Name, "Unprotected", event)}
                                        aria-label={`${player.Name} Unprotected round ${round}`}
                                    />
                                    <Form.Control
                                        type="number"
                                        defaultValue={score.ProtectedCash ?? 0}
                                        onBlur={(event) => updateGameData(round, player.Name, "Protected", event)}
                                        aria-label={`${player.Name} Protected round ${round}`}
                                    />
                                    <Form.Control
                                        type="number"
                                        defaultValue={score.Penalties ?? 0}
                                        onBlur={(event) => updateGameData(round, player.Name, "Penalties", event)}
                                        aria-label={`${player.Name} Penalties round ${round}`}
                                    />
                                    <Form.Check
                                        type="checkbox"
                                        label="Banker"
                                        defaultChecked={Boolean(score.Banker)}
                                        onChange={(event) => handleBankerChange(round, player.Name, event)}
                                    />
                                    <span className="ms-2">Score: {score.Score}</span>
                                </div>
                            </div>
                        );
                    })}
                    <Button onClick={() => calculateRound(round)} variation="primary">
                        Calculate Round
                    </Button>
                </Accordion.Body>
            </Accordion.Item>
        ));
    const playDrumRoll = async () => {
        await playDrumrollAudio();
    };

    const updateRoundSummary = (mapToUse = roundMapRef.current, snapshotRound = currentRound + 1) => {
        let newRoundSummary = []
        let rounds = new Set()
        mapToUse.forEach((rpMap, round) => {
            rounds.add(round)
            rpMap.forEach((score, player) => {
                newRoundSummary.push( { Round: round, Score: score.Score, Player: player } )
            }) 
        })
        let sortedNewRoundSummary= newRoundSummary.sort((a,b) => {
            if(a.Round < b.Round) {
                return -1;
            } else if(a.Round > b.Round) {
                return 1
            } else if(a.Round == b.Round) {
                return b.Score - a.Score 
            } else {
                return 0
            }
        })
        setRoundSummaryData(sortedNewRoundSummary)

        //total summary
        let gameSumm = []
        players.forEach((player) => {
            let playerTotal= 0
            rounds.forEach( (round) => {
                let rpMap = mapToUse.get(round)
                const score = rpMap?.get(player.Name)
                if (score) playerTotal += score.Score
            })
            gameSumm.push({ Player: player.Name, Total: playerTotal})
            savePlayer(player, playerTotal)
        })
        setGameSummaryData(gameSumm.sort((a,b) => {
            return b.Total - a.Total 
        }))
        // persist snapshot of current state for resume (include detailed rounds)
        try {
            if (activeGameId) {
                const snapshotPlayers = players.map(p => ({ id: p.id, Name: p.Name }));
                const completedRoundsDetailed = Array.from(mapToUse.entries()).map(([roundNum, rpMap]) => ({
                    roundNumber: roundNum,
                    scores: Array.from(rpMap.entries()).map(([playerName, data]) => ({
                        playerName,
                        Score: data.Score,
                        Skim: data.Skim,
                        Banker: data.Banker,
                        Unprotected: data.Unprotected,
                        ProtectedCash: data.ProtectedCash,
                        Penalties: data.Penalties
                    }))
                }));
                updateActiveGame(activeGameId, {
                    players: snapshotPlayers,
                    snapshot: { players: snapshotPlayers, initialDealer, currentRound: snapshotRound, completedRounds: completedRoundsDetailed }
                });
                console.log("[Grass resume] saved snapshot:", {
                    activeGameId,
                    players: snapshotPlayers,
                    completedRounds: completedRoundsDetailed
                });
            }
        } catch (e) {
            console.error("[Grass resume] failed to save snapshot:", e);
        }
    }

    const calculateRound = (roundNumber) => {
        const updatedRoundMap = new Map(roundMapRef.current);
        const currentRoundMap = new Map(updatedRoundMap.get(roundNumber) || []);
        const roundData = gameData.current[roundNumber] || {};

        players.forEach((player) => {
            const values = roundData[player.Name] || {};
            const unprotected = Number.isNaN(values.Unprotected) ? 0 : (values.Unprotected || 0);
            const protectedCash = Number.isNaN(values.Protected) ? 0 : (values.Protected || 0);
            const penalties = Number.isNaN(values.Penalties) ? 0 : (values.Penalties || 0);
            const banker = Boolean(values.Banker);
            const skim = banker ? 0 : -0.2 * unprotected;
            currentRoundMap.set(player.Name, {
                Score: unprotected + protectedCash + skim - penalties,
                Skim: skim,
                Banker: banker,
                Unprotected: unprotected,
                ProtectedCash: protectedCash,
                Penalties: penalties
            });
        });

        let highScore = -999;
        let winningEntries = [];
        let bankTotal = 0;
        let bankerEntry;
        currentRoundMap.forEach((entry) => {
            if (entry.Score > highScore) {
                winningEntries = [entry];
                highScore = entry.Score;
            } else if (entry.Score === highScore) {
                winningEntries.push(entry);
            }
            if (entry.Banker) bankerEntry = entry;
            else bankTotal += -1 * entry.Skim;
        });
        if (bankerEntry) bankerEntry.Score += bankTotal;
        const sharedWinBonus = Math.floor(20 / winningEntries.length);
        winningEntries.forEach((entry) => { entry.Score += sharedWinBonus; });

        updatedRoundMap.set(roundNumber, currentRoundMap);
        roundMapRef.current = updatedRoundMap;
        setRoundMap(updatedRoundMap);
        updateRoundSummary(
            updatedRoundMap,
            roundNumber === currentRound ? currentRound + 1 : currentRound
        );
        setLastRoundData({
            round: roundNumber,
            scores: Array.from(currentRoundMap.entries()).map(([name, data]) => ({
                player: name,
                score: data.Score,
                unprotected: data.Unprotected,
                protected: data.ProtectedCash,
                skim: data.Skim,
                penalties: data.Penalties,
                banker: data.Banker
            })).sort((a, b) => b.score - a.score)
        });
        setShowRoundSummary(true);
        console.log("[Grass round] recalculated:", { round: roundNumber, bonusEach: sharedWinBonus });
    };

    // Hydrate roundMap and summaries when resuming
    React.useEffect(() => {
        const resumed = location.state?.activeGameSnapshot || null;
        console.log("[Grass resume] snapshot:", resumed);
        console.log("[Grass resume] completed rounds:", resumed?.completedRounds);
        if (resumed && Array.isArray(resumed.completedRounds) && resumed.completedRounds.length > 0) {
            const map = new Map();
            resumed.completedRounds.forEach(cr => {
                const rpMap = new Map();
                console.log("[Grass resume] restoring round:", cr.roundNumber, cr.scores);
                (cr.scores || []).forEach(s => {
                    console.log("[Grass resume] restoring score:", {
                        round: cr.roundNumber,
                        playerName: s.playerName,
                        score: s.Score,
                        details: s
                    });
                    rpMap.set(s.playerName, {
                        Score: s.Score,
                        Skim: s.Skim,
                        Banker: s.Banker,
                        Unprotected: s.Unprotected,
                        ProtectedCash: s.ProtectedCash,
                        Penalties: s.Penalties
                    });
                    if (!gameData.current[cr.roundNumber]) gameData.current[cr.roundNumber] = {};
                    gameData.current[cr.roundNumber][s.playerName] = {
                        Unprotected: s.Unprotected ?? 0,
                        Protected: s.ProtectedCash ?? 0,
                        Penalties: s.Penalties ?? 0,
                        Banker: Boolean(s.Banker)
                    };
                });
                map.set(cr.roundNumber, rpMap);
            });
            console.log("[Grass resume] reconstructed round map:", Array.from(map.entries()).map(([round, scores]) => ({
                round,
                scores: Array.from(scores.entries())
            })));
            roundMapRef.current = map;
            setRoundMap(map);
            restoreSummaries(map);
            // focus on current round panel
            try { setCurrentPanel(resumed.currentRound || 1); } catch (e) {}
        }
    }, []);


    const checkMultiple = (e) => {
        console.log("Check : ", e)
        if(e % 5 == 0) {
            console.log("OK")
            return true
        }else {
            console.log("FAIL")
            return false
        }
    }

    const restoreSummaries = (map) => {
        const restoredRoundSummary = [];
        const rounds = new Set();

        map.forEach((playerRoundMap, round) => {
            rounds.add(round);
            playerRoundMap.forEach((score, player) => {
                restoredRoundSummary.push({ Round: round, Score: score.Score, Player: player });
            });
        });

        setRoundSummaryData(restoredRoundSummary.sort((a, b) => {
            if (a.Round !== b.Round) return a.Round - b.Round;
            return b.Score - a.Score;
        }));
        console.log("[Grass resume] round summary:", restoredRoundSummary);

        const restoredGameSummary = players.map((player) => {
            let total = 0;
            rounds.forEach((round) => {
                const score = map.get(round)?.get(player.Name);
                if (score) total += score.Score;
            });
            return { Player: player.Name, Total: total };
        });
        setGameSummaryData(restoredGameSummary.sort((a, b) => b.Total - a.Total));
        console.log("[Grass resume] game summary:", restoredGameSummary);
    };

    const updateGameData= (round, playerName, field, e) => {
        if(field != "Banker") {
            if(!checkMultiple(e.target.value)) {
                e.target.value = null
            } else {
                console.log("Ref:", gameData.current)
                console.log("set ", round, playerName, field, e.target.valueAsNumber)
                //gameData.get(round).get(playerName)[field] = e.target.valueAsNumber
                gameData.current[round][playerName][field] = e.target.valueAsNumber
            }
        } else {
            //gameData.get(round).get(playerName)[field] = e.target.checked
            gameData.current[round][playerName][field] = e.target.checked
        }
    }

    const handleBankerChange = (round, playerName, e) => {
        // If trying to set banker to true, check if another player is already banker
        if(e.target.checked) {
            let existingBanker = null;
            // Check all players in this round
            for(let pName in gameData.current[round]) {
                if(pName !== playerName && gameData.current[round][pName].Banker === true) {
                    existingBanker = pName;
                    break;
                }
            }
            
            if(existingBanker) {
                window.alert(`${existingBanker} has already been set as banker for this round. Please uncheck ${existingBanker} first.`);
                // Reset the checkbox by not calling updateGameData
                e.target.checked = false;
                return;
            }
        }
        
        // If we get here, the change is valid
        updateGameData(round, playerName, "Banker", e);
    }

    // Native value setter so React-controlled or plain DOM inputs both update
    // visibly when we populate them programmatically from voice input.
    const setNativeInputValue = (input, value) => {
        const proto =
            input.type === "checkbox"
                ? window.HTMLInputElement.prototype
                : window.HTMLInputElement.prototype;
        const descriptor = Object.getOwnPropertyDescriptor(
            proto,
            input.type === "checkbox" ? "checked" : "value"
        );
        if (descriptor && descriptor.set) {
            if (input.type === "checkbox") input.checked = value;
            else input.value = value;
        }
    };

    // Apply parsed voice values for a single player/round into the form fields.
    // Writes the visible input values AND triggers the existing handlers so the
    // gameData ref + validation (multiple-of-5, one-banker-per-round) stay intact.
    const applyVoiceScores = (round, playerName, values) => {
        // Resolve the actual <input> for a field id. The Unprotected group sets
        // the same id on both its wrapper div and the control, so getElementById
        // alone can return the wrapper; fall back to a scoped input lookup.
        const findInput = (id) => {
            const el = document.getElementById(id);
            if (el && el.tagName === "INPUT") return el;
            if (el) {
                const nested = el.querySelector && el.querySelector("input");
                if (nested) return nested;
            }
            // Last resort: query for an input carrying that id anywhere.
            const bySelector = document.querySelector(`input[id="${id}"]`);
            return bySelector || null;
        };

        const numericFields = ["Unprotected", "Protected", "Penalties"];
        numericFields.forEach((field) => {
            const id = playerName.concat("-", field, round);
            const input = findInput(id);
            if (input) {
                setNativeInputValue(input, String(values[field]));
                // Fire blur so updateGameData runs exactly as a manual entry would.
                input.dispatchEvent(new Event("blur", { bubbles: true }));
            } else {
                // Fallback: write straight to the data ref if the DOM node isn't found.
                if (gameData.current[round] && gameData.current[round][playerName]) {
                    gameData.current[round][playerName][field] = values[field];
                }
            }
        });

        // Banker via the checkbox so handleBankerChange enforces the one-banker rule.
        const bankerId = playerName.concat("-Banker", round);
        const bankerInput = findInput(bankerId);
        if (bankerInput) {
            const currentlyChecked = bankerInput.checked;
            if (currentlyChecked !== values.Banker) {
                setNativeInputValue(bankerInput, values.Banker);
                bankerInput.dispatchEvent(new Event("click", { bubbles: true }));
                bankerInput.dispatchEvent(new Event("change", { bubbles: true }));
            }
        } else if (gameData.current[round] && gameData.current[round][playerName]) {
            gameData.current[round][playerName].Banker = values.Banker;
        }
    };

    const newRound = ()  => {
        let nextRound= currentRound
        //let playerRoundData = new Map()
        //gameData.set(nextRound, playerRoundData)
        let playerRoundData = {}

        let roundPlayerUI = []
        players.forEach((player) => {
            //playerRoundData.set(player.Name, { Unprotected: 10, Protected: 0, Penalties: 0, Banker: false })
            playerRoundData[player.Name] = { Unprotected: 0, Protected: 0, Penalties: 0, Banker: false }
            roundPlayerUI.push (
                <Accordion key={player.Name.concat("-accordion-", nextRound)}>
                    <Accordion.Item eventKey={player.Name.concat("-", nextRound)}>
                        <Accordion.Header>
                                {player.Name}
                        </Accordion.Header>
                        <Accordion.Body>
                                <Flex justifyContent="flex-end" className="mb-2">
                                    <VoiceScoreButton
                                        playerName={player.Name}
                                        onApply={(values) => applyVoiceScores(nextRound, player.Name, values)}
                                    />
                                </Flex>
                                <Form.Group as={Row} controlId={player.Name.concat("-Unprotected",nextRound)} id={player.Name.concat("-Unprotected",nextRound)}>
                                    <Form.Label column sm={2}>Unprotected</Form.Label>
                                    <Col>
                                        <Form.Control type="number" inputMode="numeric" placeholder="Unprotected" 
                                        onBlur={ (e) => {updateGameData(nextRound, player.Name, "Unprotected", e)} }
                                        />
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row} controlId={player.Name.concat("-Protected",nextRound)}>
                                    <Form.Label column sm={2}>Protected</Form.Label>
                                    <Col>
                                        <Form.Control type="number" inputMode="numeric" placeholder="Protected" onBlur={ (e) => {updateGameData(nextRound, player.Name, "Protected", e)} }/>
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row} controlId={player.Name.concat("-Penalties",nextRound)}>
                                    <Form.Label column sm={2}>Penalties</Form.Label>
                                    <Col>
                                        <Form.Control type="number" inputMode="numeric" placeholder="Penalties" onBlur={ (e) => {updateGameData(nextRound, player.Name, "Penalties", e)} }/>
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row} controlId={player.Name.concat("-Banker",nextRound)} className="mt-3">
                                    <Col>
                                        <Form.Check type="checkbox" label="Banker" id={player.Name.concat("-Banker",nextRound)} onChange={ (e) => {handleBankerChange(nextRound, player.Name, e)} }/>
                                    </Col>
                                </Form.Group>
                        </Accordion.Body>
                    </Accordion.Item>
                </Accordion>
            )
            
        });
        let roundUI = (
            
                <Accordion.Item key={nextRound} data-round={nextRound} eventKey={nextRound}><Accordion.Header>Round {nextRound} - Dealer: {getDealerForRound(nextRound)}</Accordion.Header>
                <Accordion.Body>
                <Form>
                        {roundPlayerUI}
                        <Flex
                            justifyContent="center">
                            <Button type="submit" onClick={(e) => {
                                e.preventDefault()
                                const updatedRoundMap = new Map(roundMapRef.current);
                                const currentRoundMap = new Map(updatedRoundMap.get(nextRound) || []);
                                players.forEach((player) => {
                                    //let unprotected= gameData.get(nextRound).get(player.Name)["Unprotected"]
                                    let unprotected= gameData.current[nextRound][player.Name]["Unprotected"]
                                    if(isNaN(unprotected)) unprotected = 0
                                    //let protectedCash= gameData.get(nextRound).get(player.Name)["Protected"]
                                    let protectedCash= gameData.current[nextRound][player.Name]["Protected"]
                                    if(isNaN(protectedCash)) protectedCash = 0
                                    //let penalties= gameData.get(nextRound).get(player.Name)["Penalties"]
                                    let penalties= gameData.current[nextRound][player.Name]["Penalties"]
                                    if(isNaN(penalties)) penalties = 0
                                    //let banker= gameData.get(nextRound).get(player.Name)["Banker"]
                                    let banker= gameData.current[nextRound][player.Name]["Banker"]

                                    let skim = banker ? 0 : -0.2 * unprotected
                                    let total = unprotected + protectedCash + skim - penalties
                                    currentRoundMap.set(player.Name, { Score: total, Skim: skim, Banker: banker, Unprotected: unprotected, ProtectedCash: protectedCash, Penalties: penalties })
                                })
                                updatedRoundMap.set(nextRound, currentRoundMap)
                                roundMapRef.current = updatedRoundMap
                                setRoundMap(updatedRoundMap)
                                let rpMap = currentRoundMap
                                let highScore = -999
                                let winningEntries = []
                                let bankTotal = 0
                                let bankerEntry = undefined
                                let winBonus = 20
                                rpMap.forEach( (entry, playerName) => {
                                    if(entry.Score > highScore) {
                                        winningEntries = [entry]
                                        highScore = entry.Score
                                    } else if(entry.Score === highScore) {
                                        winningEntries.push(entry)
                                    }
                                    if(entry.Banker) {
                                        bankerEntry= entry
                                    } else {
                                        bankTotal+= (-1*entry.Skim)
                                    }
                                })
                                if (bankerEntry) {
                                    bankerEntry.Score = bankerEntry.Score + bankTotal
                                }
                                const sharedWinBonus = Math.floor(winBonus / winningEntries.length)
                                winningEntries.forEach((entry) => {
                                    entry.Score = entry.Score + sharedWinBonus
                                })
                                console.log("[Grass round] bonus applied:", {
                                    round: nextRound,
                                    winners: winningEntries.length,
                                    bonusEach: sharedWinBonus
                                })
                                // Save immediately so a sign-out while the summary is open
                                // cannot discard the newly calculated round or its bonus.
                                updateRoundSummary(updatedRoundMap)

                                // Prepare round data for modal
                                let roundScores = Array.from(rpMap.entries()).map(([name, data]) => ({
                                    player: name,
                                    score: data.Score,
                                    unprotected: data.Unprotected,
                                    protected: data.ProtectedCash,
                                    skim: data.Skim,
                                    penalties: data.Penalties,
                                    banker: data.Banker
                                })).sort((a, b) => b.score - a.score);

                                setLastRoundData({
                                    round: nextRound,
                                    scores: roundScores
                                });
                                playDrumRoll();
                                setShowRoundSummary(true);
                            }}>Calculate Round</Button>
                        </Flex>
                        </Form>
                    </Accordion.Body>
                </Accordion.Item>
            
            )

        

        let newRounds = [ ...Rounds, roundUI ]
        setRounds(newRounds)
        //setCurrentRound(nextRound)
        setCurrentPanel(nextRound)

        console.log("player round data: ", playerRoundData)
        gameData.current[nextRound] = playerRoundData
        
    }

    const handleCloseRoundSummary = () => {
        setShowRoundSummary(false);
        console.log("[Grass resume] closing summary with rounds:", Array.from(roundMapRef.current.keys()));
        const nextRound = lastRoundData?.round === currentRound ? currentRound + 1 : currentRound;
        updateRoundSummary(roundMapRef.current, nextRound);
    };

    const handleOnSelectPanel = (e) => {
        setCurrentPanel(e || null)
    }
    return (
        <div>
        <Accordion activeKey={currentPanel} onSelect={handleOnSelectPanel}>
            {restoredRoundPanels}
            {Rounds}
        </Accordion>
        
        <Grid
            as="form"
            rowGap="15px"
            columnGap="15px"
            padding="20px"
            onSubmit={async (event) => {
                event.preventDefault();
                setShowEndGameConfirm(true);
            }}
        >
            
            <Flex
            justifyContent="space-between"
            {...getOverrideProps(overrides, "CTAFlex")}
            >
                <Button
                children="New Round"
                onClick={() => {setCurrentPanel(null); setCurrentRound(currentRound => currentRound + 1)}}>New Round</Button>
                <Flex
                gap="15px"
                {...getOverrideProps(overrides, "RightAlignCTASubFlex")}
                ></Flex>
                <Flex
                gap="15px"
                {...getOverrideProps(overrides, "RightAlignCTASubFlex")}
                >
                <Button
                    children="End Game"
                    className="end-game-button"
                    type="submit"
                    variation="primary"
                    isDisabled={Object.values(errors).some((e) => e?.hasError)}
                ></Button>
                </Flex>
            </Flex>
            
            <Table size="sm">
                <thead>
                    <tr>
                        <th>Round</th>
                        <th>Player</th>
                        <th>Score</th>
                    </tr>
                </thead>
                <tbody>
                    {roundSummaryData.map((item, i) => (
                        <tr key={item.Round + "-" + item.Player + "-" + i}>
                            <td>{item.Round}</td>
                            <td>{item.Player}</td>
                            <td>{item.Score}</td>
                        </tr>
                    ))}
                </tbody>
            </Table>
            
            <Table size="sm">
                <thead>
                    <tr>
                        <th>Player</th>
                        <th>Total</th>
                    </tr>
                </thead>
                <tbody>
                    {gameSummaryData.map((item, i) => (
                        <tr key={item.Player}>
                            <td>{item.Player}</td>
                            <td>{item.Total}</td>
                        </tr>
                    ))}
                </tbody>
            </Table>
        </Grid>

        <Modal show={showRoundSummary} onShow={playDrumRoll} onHide={handleCloseRoundSummary} centered size="lg">
            <Modal.Header closeButton>
                <Modal.Title style={{ fontSize: "1.65rem", fontWeight: "bold" }}>Round {lastRoundData?.round} Results</Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ padding: "20px", fontSize: "1.1rem" }}>
                {lastRoundData && (
                    <>
                        <div style={{ marginBottom: "25px" }}>
                            <h5 style={{ fontSize: "1.25rem", fontWeight: "bold", marginBottom: "15px" }}>Round Scores (High to Low)</h5>
                            <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                                {lastRoundData.scores.map((item, idx) => (
                                    <div key={idx} style={{
                                        padding: "12px",
                                        backgroundColor: "#f8f9fa",
                                        borderRadius: "5px",
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        borderLeft: item.banker ? "4px solid #FFD700" : "4px solid transparent"
                                    }}>
                                        <span style={{ fontSize: "1.5rem", fontWeight: "bold" }}>
                                            {item.player} {item.banker ? "🏦" : ""}
                                        </span>
                                        <span style={{ fontSize: "1.5rem", fontWeight: "bold", color: item.score > 0 ? "#28a745" : "#dc3545" }}>
                                            {item.score > 0 ? "+" : ""}{item.score}
                                        </span>
                                    </div>
                                ))}
                            </div>
                        </div>

                        <div style={{ marginBottom: "25px" }}>
                            <h5 style={{ fontSize: "1.25rem", fontWeight: "bold", marginBottom: "15px" }}>Banking Summary</h5>
                            <div style={{ backgroundColor: "#f8f9fa", padding: "12px", borderRadius: "5px", fontSize: "1.05rem" }}>
                                {lastRoundData.scores.map((item, idx) => (
                                    <div key={idx} style={{ marginBottom: "8px" }}>
                                        <strong>{item.player}:</strong> Unprotected: {item.unprotected}, Protected: {item.protected}, Skim: {item.skim.toFixed(2)}, Penalties: -{item.penalties}
                                    </div>
                                ))}
                            </div>
                        </div>

                        <div>
                            <h5 style={{ fontSize: "1.25rem", fontWeight: "bold", marginBottom: "15px" }}>Current Totals</h5>
                            <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                                {(() => {
                                    // Calculate totals including the current round
                                    let currentTotals = [];
                                    let rounds = new Set();
                                    roundMap.forEach((rpMap, round) => {
                                        rounds.add(round);
                                    });
                                    
                                    players.forEach((player) => {
                                        let playerTotal = 0;
                                        rounds.forEach((round) => {
                                            let rpMap = roundMap.get(round);
                                            playerTotal += rpMap.get(player.Name).Score;
                                        });
                                        currentTotals.push({ Player: player.Name, Total: playerTotal });
                                    });
                                    
                                    return currentTotals.sort((a, b) => b.Total - a.Total).map((item, idx) => (
                                        <div key={idx} style={{
                                            padding: "10px",
                                            backgroundColor: "#e7f3ff",
                                            borderRadius: "5px",
                                            display: "flex",
                                            justifyContent: "space-between"
                                        }}>
                                            <span style={{ fontSize: "1.2rem", fontWeight: "bold" }}>{item.Player}</span>
                                            <span style={{ fontSize: "1.2rem", fontWeight: "bold" }}>{item.Total}</span>
                                        </div>
                                    ));
                                })()}
                            </div>
                        </div>
                    </>
                )}
            </Modal.Body>
            <Modal.Footer style={{ padding: "15px" }}>
                <Button onClick={handleCloseRoundSummary} className="btn btn-primary" style={{ fontSize: "1rem" }}>
                    Continue
                </Button>
            </Modal.Footer>
        </Modal>

        <Modal show={showEndGameConfirm} onHide={() => setShowEndGameConfirm(false)} centered>
            <Modal.Header closeButton>
                <Modal.Title>End Game?</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                Are you sure you want to end the game?
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={() => setShowEndGameConfirm(false)} className="btn btn-secondary">
                    Cancel
                </Button>
                <Button onClick={() => {
                        setShowEndGameConfirm(false);
                        try { if (activeGameId) removeActiveGame(activeGameId); } catch (e) {}
                        navigate("/");
                }} className="btn btn-primary">
                    End Game
                </Button>
            </Modal.Footer>
        </Modal>
        </div>
    );
}
